import { Briefcase } from '@phosphor-icons/react';
import DirectoryTooltipContent, {
  directoryTooltipContentClassName,
} from './DirectoryTooltipContent';

type BusinessGroupTooltipItem = {
  id: string;
  name: string;
  logoUrl?: string | null;
};

export const businessGroupTooltipContentClassName =
  directoryTooltipContentClassName;

const BusinessGroupTooltipList = ({
  businessGroups,
  label,
}: {
  businessGroups: BusinessGroupTooltipItem[];
  label: string;
}) => (
  <DirectoryTooltipContent title={label}>
    {businessGroups.map((businessGroup) => (
      <li key={businessGroup.id} className="flex min-w-0 items-center gap-2">
        <span className="relative flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-md border border-[#E8EBF3] bg-white p-1 text-[#1A162F] shadow-xs">
          <Briefcase size={14} weight="bold" aria-hidden="true" />
          {businessGroup.logoUrl ? (
            <img
              src={businessGroup.logoUrl}
              alt=""
              className="absolute h-4 w-4 bg-white object-contain"
              onError={(event) => {
                event.currentTarget.style.display = 'none';
              }}
            />
          ) : null}
        </span>
        <span className="min-w-0 break-words text-xs font-medium leading-5 text-[#1A162F]">
          {businessGroup.name}
        </span>
      </li>
    ))}
  </DirectoryTooltipContent>
);

export default BusinessGroupTooltipList;
